<div class="project-card" (click)="navigateToProjectDetails(project.id || 1)">

    <div class="card-image">
        <img [src]="project.imageUrl" [alt]="project.title">
        <div class="image-overlay"></div>
        <span class="sector-badge">
            <span class="material-icons" style="font-size: 15px; vertical-align: middle; margin-right: 4px;">
                {{ getBusinessAreaIcon(project.businessArea) }}
            </span>
            {{ project.businessArea }}
        </span>
    </div>

    <div class="card-body">
        <h3 class="card-title">{{ project.title }}</h3>
        <p class="card-description">{{ project.description }}</p>

        <div class="card-footer">
            <div class="client-info">
                <img class="client-logo" [src]="project.clientLogoUrl" [alt]="project.client">
                <span class="client-name">{{ project.client }}</span>
            </div>
            <span class="cta-link">
                Ver proyecto
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
            </span>
        </div>
    </div>

</div>